<div class="mnt-content mdl-grid mdl-grid--no-spacing">
  <div class="mdl-cell mdl-cell--12-col">

        <itec-form
            name="ctrl.formulari.nom"
            fields="ctrl.formulari.camps"
            ng-model="ctrl.cercaObj"
            ng-submit-function="ctrl.formulari.func()"
            errors="ctrl.errors"
            submit-button-text="DEFAULT_CERCAR"
            backbutton="false"
            submit-button-dynamic="false">
          </itec-form>
  </div>
  <div class="mdl-cell mdl-cell--12-col">
    <md-card>
      <md-card-content>
        <div class="mdl-grid mdl-grid--no-spacing">

          <itec-simple-list
            class="mdl-cell mdl-cell--12-col"
            items="ctrl.llista"
            fields="ctrl.fields"
            show-edit-button="::$root.permisos.ACTUALITZARPRODUCTE.edit"
            show-delete-button="::$root.permisos.ESBORRARPRODUCTE.delete"
            show-add-button="false"
            show-clone-button="::$root.permisos.AFEGIRPRODUCTE.add"
            itec-dialog-confirm-title="DEFAULT_TITOL_CONFIRMACIO_ESBORRAR"
            itec-dialog-confirm-text-content="PRODUCTE_DELETE_CONTENT"
            itec-infinite-scroll-function="ctrl.load"
            threshold="100"
            can-load="ctrl.canLoad"
            delete-function="ctrl.deleteProductes"
            click-function="ctrl.view"
            all-row-clickable="true"
            clone-function="ctrl.duplicate"
            edit-function="ctrl.edit"
            id-selected="$stateParams.idProducte">
          </itec-simple-list>
        </div>
      </md-card-content>
    </md-card>
  </div>
</div>
